/* Bagulia: opens the newsletter popup (#atc-popup) once after a successful add-to-cart.
   Never shows again after the visitor subscribes or after it has been shown once (30 days). */
(function () {
  "use strict";
  if (window.Shopify && window.Shopify.designMode) return;
  var NS = "bagulia-atc-popup";
  function get(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return undefined;
      var item = JSON.parse(raw);
      if (item.expires && Date.now() > item.expires) {
        localStorage.removeItem(key);
        return undefined;
      }
      return item.value;
    } catch (e) {
      return undefined;
    }
  }
  function set(key, value, days) {
    try {
      localStorage.setItem(
        key,
        JSON.stringify({ value: value, expires: days ? Date.now() + days * 864e5 : null })
      );
    } catch (e) {}
  }
  if (window.location.search.indexOf("customer_posted=true") > -1) {
    set(NS + "-done", 1, 365);
  }
  document.addEventListener(
    "submit",
    function (e) {
      if (e.target && e.target.closest && e.target.closest("#atc-popup")) {
        set(NS + "-done", 1, 365);
      }
    },
    true
  );
  function openPopup() {
    var p = document.getElementById("atc-popup");
    if (!p || p.classList.contains("popup-open")) return;
    p.classList.add("popup-open");
    var w = p.querySelector(".popup-wrap");
    var anim = p.getAttribute("data-open-animation") || "popupOpenFade";
    if (w) {
      w.classList.add("popup-animated", anim);
      w.addEventListener("animationend", function h() {
        w.classList.remove("popup-animated", anim);
        w.removeEventListener("animationend", h);
      });
    }
    set(NS + "-shown", 1, 30);
  }
  var origFetch = window.fetch;
  window.fetch = function () {
    var args = arguments;
    var url = "";
    try {
      url = typeof args[0] === "string" ? args[0] : (args[0] && args[0].url) || "";
    } catch (e) {}
    var result = origFetch.apply(this, args);
    if (String(url).indexOf("/cart/add") > -1) {
      result
        .then(function (res) {
          if (res && res.ok && !get(NS + "-done") && !get(NS + "-shown")) {
            setTimeout(openPopup, 1500);
          }
          return res;
        })
        .catch(function () {});
    }
    return result;
  };
})();
